import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const BRANDED_ICON_LIBRARY_FLAG_KEY = 'release-branded-icon-library';
export const BRANDED_ICON_LIBRARY_FLAG_DEFAULT = false;

/**
 * Flagsmith: swaps lucide icons for Heidi's branded glyphs app-wide via a build
 * alias (see `packages/design-system/src/icons/heidi-product-glyphs/`). Read
 * once by `DesignSystemProvider`, not per icon. Default OFF.
 */
export const useIsBrandedIconLibraryEnabled = () =>
  useBooleanFlagValue(BRANDED_ICON_LIBRARY_FLAG_KEY, BRANDED_ICON_LIBRARY_FLAG_DEFAULT);
